import { useCallback } from 'react'
import { useVerificationFlow } from '../../../Components/shared/VerificationFlow'
import { useSelector } from 'react-redux'
import { selectHomeId } from '../../../store/selectors/home'
import { selectClientId } from '../../../store/selectors/client'
import { createBuyerMessage, createHomeownerMessage } from '../../../api/mikasa/requests'
import { CUSTOMER_MESSAGES } from '../../../constants/customerMessages'
import { selectBuyerId } from '../../../store/selectors/buyerInfo'
import * as Sentry from '@sentry/browser'

/**
 * This hook is a bit of a misnomer. It isn't used for sending listing messages.
 * We probably need to update our flow to pass in the message logic vs.
 * assuming it all works the same way
 *
 * @returns
 */
export const useSendMessageStep = () => {
  const homeId = useSelector(selectHomeId)
  const clientId = useSelector(selectClientId)
  const buyerId = useSelector(selectBuyerId)

  const { state, dispatch } = useVerificationFlow()
  const { topicKey, metadata } = state

  const sendMessage = async (message: string): Promise<void> => {
    try {
      if (homeId && message) {
        await createHomeownerMessage(
          homeId,
          {
            topic: Object.values(CUSTOMER_MESSAGES).find(msg => msg.topicKey === topicKey)?.topic,
            topicKey: topicKey,
            message: message,
            clientId: clientId,
            metadata: metadata
          },
          null
        )
      } else if (buyerId && message) {
        await createBuyerMessage(
          buyerId,
          {
            topic: Object.values(CUSTOMER_MESSAGES).find(msg => msg.topicKey === topicKey)?.topic,
            topicKey: topicKey,
            message: message,
            metadata: metadata
          },
          null
        )
      }

      dispatch({ type: 'MESSAGE_SUCCESS' })
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          homeId,
          buyerId,
          clientId,
          topicKey,
          message
        }
      })

      throw error // Re-throw so the component can handle it
    }
  }

  return {
    sendMessage
  }
}
